module.exports = __webpack_public_path__ + "img/cooperation6.319859f1.png";